<template>
  <svg
    width="1"
    height="18"
    viewBox="0 0 1 18"
  >
    <path d="M0.5 0C0.776142 0 1 0.223858 1 0.5V17.5C1 17.7761 0.776142 18 0.5 18C0.223858 18 0 17.7761 0 17.5V0.5C0 0.223858 0.223858 0 0.5 0Z" />
  </svg>
</template>
